import "./suppressResizeObserverError";
import React from "react";
import { render } from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";

import { AppRoutes } from "./AppRoutes";
import "./api/setupAuth";
import "./i18n";
import { ConfigProvider } from "antd";
import { antdTheme } from "./theme/antdTheme";

const root = document.getElementById("root") as HTMLElement;

render(
  <React.StrictMode>
    <ConfigProvider theme={antdTheme}>
      <RouterProvider router={AppRoutes} />
    </ConfigProvider>
  </React.StrictMode>,
  root,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
